export default __webpack_public_path__ + "static/025-49bda52eb04f214f1741af4debda25dc.jpg";